import { render, staticRenderFns } from "./NormativaForm.vue?vue&type=template&id=ccc6fb7e&"
import script from "./NormativaForm.vue?vue&type=script&lang=js&"
export * from "./NormativaForm.vue?vue&type=script&lang=js&"
import style0 from "./NormativaForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports